import { Component, OnInit, Renderer2 } from '@angular/core';
import { ConfigService } from 'app/core/services/config.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilService } from '../../services/util.service';
import { AuthService } from '../../services/auth.service';
import { environment } from 'environments/environment';
import { EnvironmentService } from 'app/core/services/environment.service';

@Component({
  selector: 'itpx-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  private referrer: string;
  public logo: string;
  public year: number;
  private domainConfigData;
  isProdIn: boolean;
  isEtisalat:boolean;

  constructor(
    private configService: ConfigService,
    private router: Router,
    private route: ActivatedRoute,
    private utilService: UtilService,
    private authService: AuthService,
    private renderer: Renderer2,
    private environmentService: EnvironmentService
  ) {}

  ngOnInit() {
    const cookieDomain = this.configService.get('server').sahara.split('my.')[1]
    document.cookie = `mkp-session=;expires=-999999;path=/;domain=.${cookieDomain}`; 
    this.referrer = this.route.snapshot.queryParams['referrer'];
    this.utilService.hidePartials();
    this.setBackground();
    this.year = new Date().getFullYear();
    this.isProdIn = this.environmentService.isProdIn;
    this.isEtisalat = this.environmentService.isEtisalat;
    if(this.isProdIn || this.isEtisalat){
      const apiUrl = this.configService.get('server').apiUrl;
      let domainUrl = `${apiUrl}/domain/details/${this.isEtisalat ? 'fsp':'fsp'}`;
       this.authService.getDomainData(domainUrl).toPromise().then(response => {
        if(response && response.data){
        this.domainConfigData = response.data;
          let urlBucket = this.configService.get('aws').downloadUrl + '/' + environment.config.aws.cdnBucket;
          this.logo = urlBucket + response.data.logo.login.url;
        }
      })
    }else {
      this.logo = this.configService.get('aws').downloadUrl + this.configService.get('images').newColorEdcastLogo;
    }
  }

  ngOnDestroy() {
    this.utilService.showPartials();
    this.removeBackground();
  }

  createBuyerAccount() {
    const queryParams = {};
    if (this.referrer) queryParams['referrer'] = this.referrer;

    this.router.navigate(['/register'], { queryParams: queryParams });
  }

  createSellerAccount() {
    const queryParams = {};
    if (this.referrer) queryParams['referrer'] = this.referrer;

    this.router.navigate(['/register/seller'], { queryParams: queryParams });
  }

  onViewCatalog() {
    window.location.href = this.configService.get('server').intershop;
  }

  login() {
    this.router.navigate(['/login']);
  }

  setBackground() {
    this.renderer.setStyle(document.body, 'background-color', '#f7f7f7');
  }

  removeBackground() {
      this.renderer.removeStyle(document.body, 'background-color');
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/logout/logout.component.ts